/* eslint-disable @typescript-eslint/naming-convention, no-underscore-dangle, id-denylist, id-match */

import { Component, Input, Output, EventEmitter, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { SchemaField, Document, DocumentSchema, SystemFieldType } from 'src/app/modules/core/store/models/document.model';
import { DocumentReader } from 'src/app/modules/core/store/models/document-reader';
import { DynamicField } from '../dynamic-field';
import { ViewComponent } from '../../../store/models/workflow.model';
import { Dataset } from 'src/app/modules/core/store/models/dataset.model';
import { PicklistService } from '../../../services/picklist/picklist.service';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-multi-picklist-field',
    templateUrl: './multi-picklist-field.component.html',
    styleUrls: ['./multi-picklist-field.component.scss'],
    standalone: false
})
export class MultiPicklistFieldComponent implements DynamicField, OnDestroy {
  @Output() valueChanged = new EventEmitter<DynamicField>();
  @Input() field: SchemaField;
  @Input() displayName: string;
  @Input() layerUId: string;
  @Input() set document(value: Document) {
    this.reader = new DocumentReader(value);
  }
  reader: DocumentReader;

  @Input() viewComponent: ViewComponent;
  @Input() schema: DocumentSchema;
  isReadOnly: boolean;
  @Input() dataset: Dataset;
  selectedValue: string;
  picklistValues: any[] = [];

  get value(): any {
    return this._value;
  }
  set value(val: any) {
    if (!val) {
      val = [];
    }

    this.picklistService
      .getPicklistValues(this.field)
      .pipe(take(1))
      .subscribe(picklistValues => {
        let displayVal = '';
        for (const uid of val) {
          displayVal += `${picklistValues?.find(p => p.uId === uid)?.value}, `;
        }
        if (displayVal.length > 0) {
          displayVal = displayVal.slice(0, -2);
        }

        this.selectedValue = displayVal || '---';
      });

    this._value = val;
  }
  private _value: any = [];

  showFieldAsEdit: boolean = false;
  private _isEdit: boolean = false;
  @Input() set isEdit(edit: boolean) {
    this._isEdit = edit;

    this.calculateShouldDisplayFieldForEdit();
  }

  ngOnInit(): void {
    // Only show active picklist values for selection
    if (!!this.field.picklistDatasetUId) {
      this.picklistService
        .getPicklistValues(this.field)
        .pipe(take(1))
        .subscribe(picklistValues => {
          this.picklistValues = picklistValues?.filter(p => p.isActive === true);
          this.changeDetector.markForCheck();
        });
    } else {
      this.picklistValues = this.field?.picklistValues?.filter(p => p.isActive === true);
      this.changeDetector.markForCheck();
    }
  }

  calculateShouldDisplayFieldForEdit() {
    this.showFieldAsEdit = this._isEdit && !this.isReadOnly;
  }

  constructor(private picklistService: PicklistService, private changeDetector: ChangeDetectorRef) {}

  ngOnDestroy(): void {
    this.valueChanged.complete();
  }

  tpOnContentUpdated(): void {
    const fieldValue = this.reader.getFieldValue(this.field.systemName) || [];
    this.value = [...fieldValue];

    if ((this.field.fieldType & SystemFieldType.Editable) !== SystemFieldType.Editable || this.viewComponent?.configuration?.isReadOnly) {
      this.isReadOnly = true;
      this.calculateShouldDisplayFieldForEdit();
    }
  }

  checkChange(elm: any): void {
    const { checked, value } = elm.srcElement;
    if (checked) {
      if (!this.value.includes(value)) {
        this.value.push(value);
      }
      return;
    } else {
      const idx = this.value.findIndex(v => v === value);
      if (idx >= 0) {
        this.value.splice(idx, 1);
      }
    }

    this.onValueChanged();
  }

  onValueChanged(): void {
    this.valueChanged.emit(this);
  }
}
